import { render } from "./PartenaireItemComponents.vue?vue&type=template&id=7a0ca736"
import script from "./PartenaireItemComponents.vue?vue&type=script&lang=js"
export * from "./PartenaireItemComponents.vue?vue&type=script&lang=js"

import "./PartenaireItemComponents.vue?vue&type=style&index=0&id=7a0ca736&lang=scss"

import exportComponent from "/home/runner/work/schFront/schFront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__